<template>
    <v-layout fluid v-resize="onResize">
        <v-sheet style="width: 100%">
            <!-- Content for Accident Info -->
            <v-window v-model="step">
                <v-window-item :value="1">
                    <div class="d-flex flex-wrap justify-end align-center gap-2">
                        <v-btn
                            variant="elevated"
                            density="comfortable"
                            color="primary"
                            class="mx-2 mt-2"
                            @click="downloadPolicyPDF"
                            >
                            {{ translations.DownloadPDF }}
                        </v-btn>
                        <v-btn
                            variant="elevated"
                            density="comfortable"
                            color="primary"
                            class="mx-2 mt-2"
                            @click="translate"
                        >
                            {{ translations.ViewInSpanish }}
                        </v-btn>
                    </div>
                        
                    <h2 class="mx-auto text-center text-decoration-underline">
                        {{ translations.Title }}
                    </h2>
                    
                    <div class="mt-8 mx-auto pa-2" style="max-width: 850px;">
                        <div>
                            {{ translations.Subtitle }}
                        </div>
                        <br />
                        <div>
                            {{ translations.ListHeader }}:
                        </div>
                        <div class="mx-4 my-2">
                            <ul class="dash-list my-4">
                                <li class="my-2">
                                    {{ translations.ListItem1 }}
                                    <b class="text-decoration-underline">
                                        {{ translations.Immediately }}
                                    </b>.
                                </li>
                                <li class="my-2">
                                    <b>{{ translations.ListItem2_pt1 }}</b>
                                    {{ translations.ListItem2_pt2 }}
                                    <b>{{ translations.ListItem2_pt3 }}</b>
                                    {{ translations.ListItem2_pt4 }}
                                    <b>{{ translations.ListItem2_pt5 }} 631-365-2418</b>
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem3_pt1 }}
                                    <b class="text-decoration-underline">
                                        {{ translations.Immediately }}
                                    </b>
                                    {{ translations.ListItem3_pt2 }}
                                </li>
                            </ul>
                        </div>
                        <div
                            class="text-center text-decoration-underline my-2"
                            style="color: red;"
                        >
                            <b>
                                {{ translations.ListSubheader }}
                            </b>
                        </div>
                        <div class="mx-4 my-2">
                            <ul class="dash-list my-4">
                                <li class="my-2">
                                    <b>{{ translations.ListItem4_pt1 }}</b> 
                                    {{ translations.ListItem4_pt2 }}
                                    <b>{{ translations.ListItem4_pt3 }}</b> 
                                    {{ translations.ListItem4_pt4 }}
                                    <b>
                                        {{ translations.ListItem4_pt5 }}
                                    </b>
                                    {{ translations.ListItem4_pt6 }}
                                    <a
                                        href="mailto:accidents.d3@diaminter.com"
                                        :style="{
                                            textDecoration: 'underline',
                                            color: '#2196f3',
                                        }"
                                        >accidents.d3@diaminter.com</a
                                    >
                                    {{ translations.ListItem4_pt7 }}
                                    <b>
                                        {{ translations.ListItem4_pt8 }}
                                    </b> 
                                    {{ translations.ListItem4_pt9 }}
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem5 }}
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem6 }}
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem7 }}
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem8 }}
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem9_pt1 }}:
                                    <ul
                                        class="mx-10"
                                        style="list-style-type: circle"
                                    >
                                        <li>
                                            <b class="text-decoration-underline">
                                                {{ translations.ListItem9_pt2 }}
                                            </b>
                                            <br />
                                            {{ translations.ListItem9_pt3 }}
                                        </li>
                                        <li>
                                            <b class="text-decoration-underline">
                                                {{ translations.ListItem9_pt4 }}
                                            </b>
                                            <br />
                                            {{ translations.ListItem9_pt5 }}
                                        </li>
                                    </ul>
                                </li>
                                <li class="my-2">
                                    {{ translations.ListItem10 }}
                                </li>
                                <ul
                                    class="mx-10 my-2"
                                    style="list-style-type: circle"
                                >
                                    <li>
                                        <b>
                                            {{ translations.ListItem11_pt1 }}:
                                        </b>
                                        <ul
                                            class="mx-10"
                                            style="list-style-type: disc"
                                        >
                                            <li class="my-1">
                                                <b>
                                                    {{ translations.ListItem11_pt2 }}: 631-547-4121
                                                </b>
                                            </li>
                                            <li class="my-1">
                                                <b>
                                                    {{ translations.ListItem11_pt3 }}: 800-222-1222
                                                </b>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <li class="my-2">
                                    {{ translations.ListItem12 }}
                                </li>
                            </ul>
                        </div>
                        <v-img
                            max-height="600"
                            :src="`/images/AccidentReportPolicy_${language}.png`"
                            class="my-4"
                        />
                    </div>
                    <v-divider />
                    <div>
                        <v-card-actions>
                            <v-btn
                                v-if="step == 1"
                                size="large"
                                color="primary"
                                variant="flat"
                                block
                                @click="step++"
                            >
                                Next
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-window-item>
                <!-- End of Content for Accident -->

                <!-- Content for Employee Information -->
                <v-window-item :value="2">
                    <v-form @submit.prevent="insertAccidentReport" ref="form">
                        <div class="pa-4">
                        <div class="d-flex justify-end ">
    <div>
        <div>
            <span style="color: red" class="mr-2">*</span>
            <b>{{ translations.RequiredToBeFilled }}</b>
        </div>
        <div>
            <span style="color: black" class="mr-2">*</span>
            <b>{{ translations.FillLater }}</b>
        </div>
    </div>

    <v-btn
        variant="elevated"
        density="comfortable"
        color="primary"
        class="ml-4"
        @click="translate"
    >
        {{ translations.ViewInSpanish }}
    </v-btn>
</div>
                            <h1 class="my-4" style="font-size: 24px">
                                {{ translations.EmployeeInfo }}
                            </h1>
                            <v-row>
                                <v-col :cols="colWidth">
                                    <span class="required-label">
                                        {{ translations.Involved }}
                                    </span>
                                    <v-combobox
                                        variant="outlined"
                                        :items="employeeAccident"
                                        v-model="form.PersonInvolved"
                                        :rules="rules"
                                    />
                                </v-col>
                                <v-col :cols="colWidth">
                                    {{ translations.HomePhone }}
                                    <v-text-field
                                        clearable
                                        v-model="form.HomeNumber"
                                        variant="outlined"
                                        @keypress="isNumber($event)"
                                    />
                                </v-col>
                                <v-col :cols="colWidth">
                                    {{ translations.CellPhone }}
                                    <v-text-field
                                        clearable
                                        v-model="form.CellNumber"
                                        variant="outlined"
                                        @keypress="isNumber($event)"
                                    />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col :cols="colWidthSmall">
                                    {{ translations.DateOFBirth }}
                                    <Datepicker
                                        v-model="form.DateOfBirth"
                                        light
                                        :enable-time-picker="false"
                                        auto-apply
                                        :teleport-center="
                                            this.windowSize.x < 860
                                        "
                                        :text-input="
                                            this.editedIndex === 1
                                                ? true
                                                : false
                                        "
                                    />
                                </v-col>
                                <v-col :cols="colWidth">
                                    <span class="required-label">
                                       {{ translations.Employment }}
                                    </span>
                                    <v-radio-group
                                        :rules="rules"
                                        v-model="form.Worker"
                                        inline
                                    >
                                        <v-radio label="D3" value="D3" />
                                        <v-radio label="Temp" value="Temp" />
                                        <v-radio
                                            label="Contractor"
                                            value="Contractor"
                                        />
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-divider />
                            <!-- End Content for Employee Information-->

                            <!-- Content for Incident Information -->
                            <h1 style="font-size: 24px" class="my-4">
                                {{ translations.Incident }}
                            </h1>
                            <v-row class="d-flex align-center">
                                <v-col :cols="colWidth">
                                    <div class="d-flex align-center">
                                        <span class="required-label">
                                            {{ translations.Witness }}
                                        </span>
                                        <span class="ml-4">
                                            <v-checkbox
                                                label="None"
                                                color="blue"
                                                hide-details
                                                v-model="form.noneWitness"
                                            />
                                        </span>
                                    </div>
                                    <v-combobox
                                        :disabled="form.noneWitness"
                                        v-model="form.Witness"
                                        variant="outlined"
                                        :items="employeeAccident"
                                        :rules="rules"
                                    />
                                </v-col>

                                <v-col :cols="colWidth">
                                    <div
                                        :class="
                                            this.windowSize.x > 860
                                                ? 'my-4'
                                                : ''
                                        "
                                    >
                                        {{ translations.WorkerTitle }}
                                    </div>
                                    <v-text-field
                                        v-model="form.Title"
                                        clearable
                                        variant="outlined"
                                    />
                                </v-col>

                                <v-col :cols="colWidth">
                                    <div
                                        class="required-label"
                                        :class="
                                            this.windowSize.x > 860
                                                ? 'my-4'
                                                : ''
                                        "
                                    >
                                        {{ translations.Location }}
                                    </div>
                                    <v-text-field
                                        v-model="form.Location"
                                        clearable
                                        variant="outlined"
                                        :rules="rules"
                                    />
                                </v-col>
                            </v-row>

                            <div class="required-label mb-2">
                                {{ translations.TimeOfAccident }}
                            </div>
                            <v-row>
                                <v-col :cols="colWidthSmall">
                                    {{ translations.Date }}
                                    <Datepicker
                                        v-model="form.IncidentDate"
                                        light
                                        placeholder="Select Date"
                                        :enable-time-picker="false"
                                        auto-apply
                                        :teleport-center="
                                            this.windowSize.x < 860
                                        "
                                        :text-input="
                                            this.editedIndex === 1
                                                ? true
                                                : false
                                        "
                                    />
                                </v-col>
                                <v-col :cols="colWidthSmall">
                                    {{ translations.Time }}
                                    <Datepicker
                                        v-model="form.IncidentTime"
                                        time-picker
                                        :teleport-center="
                                            this.windowSize.x < 860
                                        "
                                        :text-input="
                                            this.editedIndex === 1
                                                ? true
                                                : false
                                        "
                                        placeholder="Select Time"
                                        :rules="rules"
                                    />
                                </v-col>

                                <v-col :cols="colWidthLarge">
                                    <span class="required-label">
                                        {{ translations.Building }}
                                    </span>
                                    <v-radio-group
                                        inline
                                        v-model="form.Building"
                                        :rules="rules"
                                    >
                                        <v-radio label="20" value="20" />
                                        <v-radio label="60" value="60" />
                                        <v-radio label="70" value="70" />
                                        <v-radio label="75" value="75" />
                                        <v-radio label="85" value="85" />
                                        <v-radio label="Pam" value="Pam" />
                                        <v-radio
                                            label="FieldFlex"
                                            value="FieldFlex"
                                        />
                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <div class="mb-2">{{ translations.EmployeeWorkHours }}</div>
                            <v-row>
                                <v-col :cols="colWidthSmall">
                                    {{ translations.From }}
                                    <Datepicker
                                        v-model="form.RegularFrom"
                                        time-picker
                                        :text-input="
                                            this.editedIndex === 1
                                                ? true
                                                : false
                                        "
                                        placeholder="Select Time"
                                        :rules="rules"
                                    />
                                </v-col>
                                <v-col :cols="colWidthSmall"
                                    >{{ translations.To }}
                                    <Datepicker
                                        v-model="form.RegularTo"
                                        time-picker
                                        :text-input="
                                            this.editedIndex === 1
                                                ? true
                                                : false
                                        "
                                        placeholder="Select Time"
                                        :rules="rules"
                                    />
                                </v-col>
                            </v-row>
                            <v-divider class="mt-6" />
                            <!-- End Content for Incident Information-->

                            <!-- Content for Incident Information -->
                            <h1 style="font-size: 24px" class="my-4">
                                {{ translations.InjuryDetails }}
                            </h1>
                            <v-row>
                                <v-col :cols="colWidth">
                                    {{ translations.NumberOfInjury }}
                                    <v-text-field
                                        v-model="form.InjuryNum"
                                        @input="generateInjuries"
                                        variant="outlined"
                                        clearable
                                        type="number"
                                        :min="0"
                                        :rules="rules"
                                    />
                                </v-col>
                            </v-row>

                            <!---Dynamic injury Fields-->
                            <div
                                v-for="(injury, index) in form._Duplicate"
                                :key="index"
                            >
                                <h1 style="font-size: 24px">
                                    {{ translations.Injury }} {{ index + 1 }}
                                </h1>

                                <v-row>
                                    <v-col :cols="colWidth">
                                        <span class="required-label">
                                            {{ translations.NatureOfInjury }}
                                        </span>
                                        <v-select
                                            v-model="
                                                form._Duplicate[index].Injury
                                            "
                                            :items=translations.InjuryList
                                            variant="outlined"
                                            :rules="rules"
                                            required
                                        />
                                    </v-col>

                                    <v-col
                                        :cols="colWidth"
                                        v-if="
                                            form._Duplicate[index].Injury ===
                                            'OTHER'
                                        "
                                    >
                                        <span class="required-label">
                                            {{ translations.ExplainOther }}
                                        </span>
                                        <v-text-field
                                            v-model="
                                                form._Duplicate[index]
                                                    .otherNatureOfInjury
                                            "
                                            variant="outlined"
                                            :rules="rules"
                                        />
                                    </v-col>
                                </v-row>

                                <span>{{ translations.PleaseExplain }}</span>
                                <v-text-field
                                    clearable
                                    variant="underlined"
                                    placeholder="Explanation"
                                    v-model="
                                        form._Duplicate[index].InjuryExplain
                                    "
                                />

                                <v-row>
                                    <v-col :cols="colWidth">
                                        <span class="required-label">
                                            {{ translations.BodyPartsAffected }}
                                        </span>
                                        <v-select
                                            v-model="
                                                form._Duplicate[index]
                                                    .AffectedParts
                                            "
                                            variant="outlined"
                                            :items=translations.BodyParts
                                            :rules="rules"
                                        />
                                    </v-col>
                                    <v-col 
                                        :cols="colWidth" 
                                        v-if="
                                            form._Duplicate[index].AffectedParts ===
                                            'OTHER'
                                        "
                                    >
                                        <span class="required-label">
                                            {{ translations.OtherBodyPartsAffected }}
                                        </span>
                                        <v-text-field
                                            
                                            variant="outlined"
                                            v-model="
                                                form._Duplicate[index]
                                                    .otherBodyPartsAffected
                                            "
                                            :rules="rules"
                                        />
                                    </v-col>
                                </v-row>
                            </div>

                            <v-row>
                                <v-col cols="6" v-if="this.windowSize.x > 860">
                                    <!-- Show medical treatment checkbox here on large screens -->
                                    <span class="semi-required-label">
                                        {{ translations.MedicalTreatment }}
                                    </span>
                                    <v-checkbox
                                        color="blue"
                                        v-model="form.MedicalTreatment"
                                    />
                                </v-col>

                                <v-col :cols="colWidth">
                                    <span class="required-label">
                                        {{ translations.TransportedToHospital }}
                                    </span>
                                    <v-select
                                        v-model="form.TransportedToHospital"
                                        :items= translations.TransportOptions
                                        variant="outlined"
                                        :rules="rules"
                                    />
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="this.windowSize.x <= 860"
                                >
                                    <!-- Move medical treatment checkbox here on small screens -->
                                    <span class="semi-required-label">
                                       {{ translations.MedicalTreatment }}
                                    </span>
                                    <v-checkbox
                                        color="blue"
                                        v-model="form.MedicalTreatment"
                                    />
                                </v-col>
                            </v-row>

                            <div v-if="form.MedicalTreatment">
                                <span class="required-label">
                                    {{ translations.TypeOfTreatment }}
                                </span>
                                <v-checkbox
                                    label="None"
                                    color="blue"
                                    v-model="form.noneTypeOfTreatment"
                                />
                                <v-text-field
                                    v-if="!form.noneTypeOfTreatment"
                                    v-model="form.TypeOfTreatment"
                                    clearable
                                    variant="underlined"
                                    placeholder="Treatment"
                                    :rules="rules"
                                />
                                <span class="required-label">
                                    {{ translations.NameOfDoctor }}
                                </span>
                                <v-text-field
                                    v-model="form.NameOfDocHos"
                                    clearable
                                    variant="underlined"
                                    placeholder="Name"
                                    :rules="rules"
                                />
                                <span>
                                    {{ translations.AddressOfDoctor }}
                                </span>
                                <v-text-field
                                    v-model="form.APOfDocHos"
                                    clearable
                                    variant="underlined"
                                    placeholder="Address/PhoneNumber"
                                />
                            </div>

                            <span class="semi-required-label">
                                {{ translations.LeaveWork }}
                            </span>
                            <v-checkbox
                                color="blue"
                                hide-details
                                v-model="form.LeaveWork"
                            />

                            <div v-if="form.LeaveWork">
                                <v-row>
                                    <v-col :cols="colWidthSmall">
                                        {{ translations.WhatTime }}
                                        <Datepicker
                                            v-model="form.LeaveWorkTime"
                                            time-picker
                                            :text-input="
                                                this.editedIndex === 1
                                                    ? true
                                                    : false
                                            "
                                            :placeholder=translations.SelectTime
                                        />
                                    </v-col>
                                </v-row>
                            </div>

                            <v-divider class="mt-6" />

                            <h1 style="font-size: 24px" class="my-4">
                                {{ translations.IncidentDescription }}
                            </h1>

                            <!-- <span class="required-label">
                                Accident Description:
                            </span>
                            <v-textarea
                                v-model="form.AccidentDescription"
                                variant="solo-filled"
                            /> -->

                            <div class="required-label">
                                {{ translations.Before }}
                            </div>
                            <div class="text-label-medium" style="color:grey">
                                {{ translations.WhatLedUp }}
                            </div>
                            <v-textarea
                                v-model="detailedDescription.before"
                                variant="outlined"
                            />

                            <div class="required-label">
                               {{ translations.During }}
                            </div>
                            <div class="text-label-medium" style="color:grey">
                                {{ translations.WhatHappenedWhile }}
                            </div>
                            <v-textarea
                                v-model="detailedDescription.during"
                                variant="outlined"
                            />

                            <div class="required-label">
                                {{ translations.After }}
                            </div>
                            <div class="text-label-medium" style="color:grey">
                                {{ translations.WhatTookPlace }}
                            </div>
                            <v-textarea
                                v-model="detailedDescription.after"
                                variant="outlined"
                            />

                            <span class="required-label">
                                {{ translations.Equipment }}
                            </span>
                            <v-checkbox
                                label="None"
                                color="blue"
                                hide-details
                                v-model="form.noneItemInvolved"
                            />
                            <v-text-field
                                v-if="!form.noneItemInvolved"
                                v-model="form.ItemInvolved"
                                :placeholder=translations.Equipment
                                variant="underlined"
                                :rules="rules"
                                class="ml-3"
                            />

                            <v-checkbox
                                v-model="form.ProperProcedure"
                                hide-details
                                color="blue"
                            >
                                <template #label>
                                    <label>
                                        <span class="required-label"
                                            >{{ translations.ProperProcedure }}</span
                                        >
                                    </label>
                                </template>
                            </v-checkbox>
                            <div v-if="!form.ProperProcedure" class="ml-3">
                                {{ translations.IfNotExplain }}
                                <v-text-field
                                    v-model="form.ProcedureExplain"
                                    :placeholder=translations.Explanation
                                    variant="underlined"
                                    :rules="rules"
                                />
                            </div>

                            <v-checkbox
                                v-model="form.WearingPPE"
                                hide-details
                                color="blue"
                            >
                                <template #label>
                                    <label>
                                        <span class="required-label"
                                            >{{ translations.WearingPPE }}</span
                                        >
                                    </label>
                                </template>
                            </v-checkbox>
                            <div v-if="!form.WearingPPE" class="ml-3">
                                {{ translations.IfNotExplain }}
                                <v-text-field
                                    v-model="form.PPEExplain"
                                    :placeholder=translations.Explanation
                                    variant="underlined"
                                    :rules="rules"
                                />
                            </div>

                            <span>{{ translations.TimeLost }}</span>
                            <v-row class="mt-2">
                                <v-col :cols="colWidthSmall">
                                    {{ translations.Days }}
                                    <v-text-field
                                        v-model="form.DaysLost"
                                        :min="0"
                                        variant="outlined"
                                        type="number"
                                    />
                                </v-col>
                                <v-col :cols="colWidthSmall">
                                    {{ translations.Hours }}
                                    <v-text-field
                                        v-model="form.HoursLost"
                                        :min="0"
                                        variant="outlined"
                                        type="number"
                                    />
                                </v-col>
                            </v-row>

                            <span>{{ translations.ReportedTo }}</span>
                            <v-checkbox
                                label="None"
                                color="blue"
                                v-model="form.noneReported"
                            />
                            <v-text-field
                                v-model="form.ReportedTo"
                                v-if="!form.noneReported"
                                variant="underlined"
                                :placeholder=translations.ReportedTo
                                clearable
                            />

                            <v-row no-gutters v-if="this.editedIndex === 1">
                                <v-col cols="12" class="required-label">
                                    {{ translations.DegreeOfInjury }}
                                </v-col>
                                <v-col cols="12">
                                    <v-btn
                                        v-for="(item, index) in FatalityOptions"
                                        :key="index"
                                        variant="elevated"
                                        :color="item.color"
                                        class="mr-1"
                                        @click="selectFatality(item, index)"
                                    >
                                        {{ item.label }}
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-file-input
                                v-model="form.imageAttachment"
                                multiple
                                chips
                                label="Attach Image(s)"
                                variant="solo-inverted"
                                prepend-icon="mdi:mdi-camera"
                                class="mt-8"
                                @click:clear="onClearClicked_Image"
                            />

                            <v-row
                                v-if="
                                    form.Images.length > 0 &&
                                    this.editedIndex === 1
                                "
                                class="mb-2 mx-2"
                                style="
                                    border: 1px dashed black;
                                    border-radius: 6px;
                                "
                            >
                                <v-col
                                    cols="3"
                                    v-for="(img, index) in form.Images"
                                    :key="index"
                                >
                                    <div class="image-container">
                                        <v-icon
                                            icon="mdi:mdi-close-thick"
                                            color="error"
                                            class="close-image"
                                            @click="removeImage(img, index)"
                                        />
                                        <v-img
                                            :src="img.Image"
                                            height="100"
                                            aspect-ratio="16/9"
                                        />
                                    </div>
                                </v-col>
                            </v-row>

                            <v-alert
                                style="margin-top: -50px"
                                v-if="successMessage"
                                type="success"
                                title="Form Submitted"
                                text="Your form is submitted successfully!"
                            />

                            <v-alert
                                style="margin-top: -50px"
                                v-if="errorMessage"
                                type="error"
                                title="Error"
                                text="Your form did not submit successfully!"
                            />

                            <v-divider />

                            <v-card-actions v-if="this.editedIndex === -1">
                                <v-btn
                                    size="large"
                                    color="red"
                                    v-if="step > 1 && step < 3"
                                    variant="flat"
                                    @click="step--"
                                >
                                    Back
                                </v-btn>
                                <v-spacer />
                                <v-btn
                                    size="large"
                                    v-if="step == 2"
                                    color="green"
                                    variant="flat"
                                    type="submit"
                                    :loading="loading"
                                >
                                    Submit
                                </v-btn>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <v-row class="text-center">
                                    <v-col>
                                        <v-btn
                                            size="large"
                                            color="green"
                                            variant="flat"
                                            type="submit"
                                            :loading="loading"
                                        >
                                            Submit
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </div>
                    </v-form>
                </v-window-item>
            </v-window>
            <!-- End Content for Incident Information-->
        </v-sheet>
    </v-layout>
</template>

<script>
import { filterTranslations } from "../../ReportAccidentTranslations";
import moment from "moment";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
    emits: ["hideAccident", "getWaitingAccidents"],
    props: {
        accident: {
            type: Object,
            default: null,
        },
    },
    watch: {
        accident: {
            handler(item) {
                if (item != null) {
                    this.editedIndex = 1;
                    this.step = 2;
                    this.form = Object.assign({}, this.accident);

                    // Format Dates and Times
                    if (this.form.DateOfBirth != null) {
                        this.form.DateOfBirth = this.formatDateForFrontEnd(
                            this.form.DateOfBirth
                        );
                    }
                    this.form.IncidentDate = this.formatDateForFrontEnd(
                        this.form.IncidentDate
                    );
                    this.form.IncidentTime = this.formatTimeForFrontEnd(
                        this.form.IncidentTime
                    );
                    this.form.RegularFrom = this.formatTimeForFrontEnd(
                        this.form.RegularFrom
                    );
                    this.form.RegularTo = this.formatTimeForFrontEnd(
                        this.form.RegularTo
                    );
                    this.form.LeaveWorkTime = this.formatTimeForFrontEnd(
                        this.form.LeaveWorkTime
                    );

                    // Format detailed description
                    this.parseAccidentDescriptionForEdit();

                    // Format Checkboxes
                    this.form.MedicalTreatment =
                        this.form.MedicalTreatment === 1;
                    this.form.LeaveWork = this.form.LeaveWork === 1;
                    this.form.ProperProcedure = this.form.ProperProcedure === 1;
                    this.form.WearingPPE = this.form.WearingPPE === 1;

                    this.form.noneWitness =
                        !this.form.Witness || this.form.Witness === "None"
                            ? true
                            : false;

                    this.form.noneTypeOfTreatment = !this.form.TypeOfTreatment;

                    this.form.noneItemInvolved =
                        !this.form.ItemInvolved ||
                        this.form.ItemInvolved === "None"
                            ? true
                            : false;

                    this.form.noneReported =
                        !this.form.ReportedTo || this.form.ReportedTo === "None"
                            ? true
                            : false;

                    // Add other fields to _Duplicate
                    this.form._Duplicate = [];
                    if (this.accident._Duplicate.length > 0) {
                        this.accident._Duplicate.forEach((injury) => {
                            this.form._Duplicate.push({
                                Injury: injury.Injury || "",
                                otherNatureOfInjury:
                                    injury.otherNatureOfInjury || "",
                                InjuryExplain: injury.InjuryExplain || "",
                                AffectedParts: injury.AffectedParts || "",
                                otherBodyPartsAffected:
                                    injury.otherBodyPartsAffected || "",
                            });
                        });
                    }
                } else {
                    this.editedIndex = -1;
                }
            },
            /*
             Also very important the immediate in case you need it,
             the callback will be called immediately after the start
             of the observation
           */
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                PersonInvolved: "",
                HomeNumber: "",
                CellNumber: "",
                DateOfBirth: null,
                Worker: "",
                noneWitness: false,
                Witness: "",
                Title: "",
                Location: "",
                IncidentDate: null,
                IncidentTime: null,
                Building: "",
                RegularFrom: null,
                RegularTo: null,
                InjuryNum: 1,
                _Duplicate: [
                    {
                        Injury: "",
                        otherNatureOfInjury: "",
                        InjuryExplain: "",
                        AffectedParts: "",
                        otherBodyPartsAffected: "",
                    },
                ],
                MedicalTreatment: false,
                noneTypeOfTreatment: false,
                TypeOfTreatment: "",
                NameOfDocHos: "",
                APOfDocHos: "",
                LeaveWork: false,
                LeaveWorkTime: null,
                TransportedToHospital: "",
                AccidentDescription: "",
                noneItemInvolved: false,
                ItemInvolved: "",
                ProperProcedure: false,
                ProcedureExplain: "",
                WearingPPE: false,
                PPEExplain: "",
                DaysLost: 0,
                HoursLost: 0,
                noneReported: false,
                ReportedTo: "",
                imageAttachment: [],
                Images: [],

                Fatality: "", // For Accident Approval Only
                emailPdf: null, //
            }),
            detailedDescription: {
                before: "",
                during: "",
                after: "",
            },
            step: 1,
            employeeAccident: [],
            rules: [
                (value) => {
                    if (value) return true;
                    return "This field is required.";
                },
            ],
            loading: false,
            successMessage: "",
            errorMessage: "",
            language: "english",
            ///////// VARS FOR ACCIDENT DASH /////////
            editedIndex: -1,
            FatalityOptions: [
                { label: "Major Accident", value: "Accident", color: "blue" },
                { label: "Minor Accident", value: "Incident", color: "blue" },
                { label: "Near Miss", value: "Near Miss", color: "blue" },
                { label: "Not Related To D3", value: "Not Related To D3", color: "blue" },
            ],

            windowSize: {
                x: 0,
                y: 0,
            },
        };
    },

    async mounted() {
        try {
            await axios.get(route("api.getEmployees")).then((res) => {
                res.data.forEach((emp) => {
                    if (!this.employeeAccident.includes(emp.fullName)) {
                        this.employeeAccident.push(emp.fullName);
                    }
                });
            });
        } catch (err) {
            console.log(err);
        }
        if (this.editedIndex === 1) {
            this.handleImages(this.form.Images);
        }
    },
    computed: {
        colWidth() {
            return this.windowSize.x > 860 ? "4" : "12";
        },
        colWidthSmall() {
            return this.windowSize.x > 860 ? "3" : "12";
        },
        colWidthLarge() {
            return this.windowSize.x > 860 ? "6" : "12";
        },
        translations() {
            return filterTranslations(this.language);
        },
    },
    methods: {
        //Check to see if the user is entering a number. Only accepts numbers
        //E is a number not used by this company therefore even if the user types in E it won't work
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        formatDateForBackend(date) {
            // Use Moment.js to format the date as 'YYYY-MM-DD'
            return moment(date).format("YYYY-MM-DD");
        },

        formatTimeForBackend(time) {
            return moment(time).format("HH:mm:ss");
        },

        generateInjuries() {
            // Update the injuries array based on the number provided by the user
            const numInjuries = parseInt(this.form.InjuryNum);

            if (!isNaN(numInjuries)) {
                const currentInjuryCount = this.form._Duplicate.length;

                if (numInjuries > currentInjuryCount) {
                    // Add new injuries
                    for (
                        let i = currentInjuryCount + 1;
                        i <= numInjuries;
                        i++
                    ) {
                        this.form._Duplicate.push({
                            Injury: "",
                            otherNatureOfInjury: "",
                            InjuryExplain: "",
                            AffectedParts: "",
                            otherBodyPartsAffected: "",
                        });
                    }
                } else if (numInjuries < currentInjuryCount) {
                    // Remove excess injuries
                    this.form._Duplicate.splice(numInjuries);
                }
            }
        },

        async insertAccidentReport() {
            this.loading = true;
            if (!this.form.PersonInvolved) {
                alert(this.translations.InvolvedAlert);
                this.loading = false;
                return;
            }

            if (!this.form.Worker) {
                alert(this.translations.EmploymentAlert);
                this.loading = false;
                return;
            }

            if (!this.form.Witness && !this.form.noneWitness) {
                alert(this.translations.WitnessAlert);
                this.loading = false;
                return;
            }

            if (!this.form.Location) {
                alert(this.translations.LocationAlert);
                this.loading = false;
                return;
            }

            if (!this.form.IncidentDate) {
                alert(this.translations.IncidentAlert);
                this.loading = false;
                return;
            }

            if (!this.form.IncidentTime) {
                alert(this.translations.IncidentTimeAlert);
                this.loading = false;
                return;
            }

            if (this.form.IncidentDate && this.form.IncidentTime) {
                const datePart = moment(this.form.IncidentDate).format(
                    "YYYY-MM-DD"
                );
                const timePart = moment(this.form.IncidentTime).format(
                    "HH:mm:ss"
                );
                const datetime = `${datePart} ${timePart}`;

                //Set the combined datetime value in the form
                this.form.IncidentDate = datetime;
            }

            if (!this.form.Building) {
                alert(this.translations.BuildingAlert);
                this.loading = false;
                return;
            }

            for (let i = 0; i < this.form.InjuryNum; i++) {
                if (!this.form._Duplicate[i].Injury) {
                    alert(this.translations.InjuryNatureAlert);
                    this.loading = false;
                    return;
                } else if (
                    this.form._Duplicate[i].Injury === "OTHER" &&
                    !this.form._Duplicate[i].otherNatureOfInjury
                ) {
                    alert(this.translations.InjuryNatureAlert);
                    this.loading = false;
                    return;
                }

                if (!this.form._Duplicate[i].AffectedParts) {
                    alert(this.translations.BodyPartAlert);
                    this.loading = false;
                    return;
                }
            }

            if (
                this.form.MedicalTreatment == 1 &&
                !this.form.TypeOfTreatment &&
                this.form.noneTypeOfTreatment == 0
            ) {
                alert(this.translations.TreatmentTypeAlert);
                this.loading = false;
                return;
            }

            if (this.form.MedicalTreatment == 1 && !this.form.NameOfDocHos) {
                alert(this.translations.DoctorAlert);
                this.loading = false;
                return;
            }

            if (!this.form.TransportedToHospital) {
                alert(this.translations.TransportedAlert);
                this.loading = false;
                return;
            }

            if (
                !this.detailedDescription.before.trim() ||
                !this.detailedDescription.during.trim() ||
                !this.detailedDescription.after.trim()
            ) {
                alert(this.translations.AccidentDescAlert);
                this.loading = false;
                return;
            }

            this.form.AccidentDescription = this.formatAccidentDescriptionForSubmission();

            if (!this.form.ItemInvolved && this.form.noneItemInvolved == 0) {
                alert(this.translations.EquipmentAlert);
                this.loading = false;
                return;
            }

            if (this.form.ProperProcedure == 0 && !this.form.ProcedureExplain) {
                alert(this.translations.ProcedueAlert);
                this.loading = false;
                return;
            }

            if (this.form.WearingPPE == 0 && !this.form.PPEExplain) {
                alert(this.translations.PPEAlert);
                this.loading = false;
                return;
            }

            if (this.editedIndex === 1 && !this.form.Fatality) {
                alert(this.translations.InjuryDegreeAlert);
                this.loading = false;
                return;
            }

            this.form.RegularFrom = this.formatTimeForBackend(
                this.form.RegularFrom
            );
            this.form.RegularTo = this.formatTimeForBackend(
                this.form.RegularTo
            );
            this.form.LeaveWorkTime = this.formatTimeForBackend(
                this.form.LeaveWorkTime
            );
            if (this.form.DateOfBirth !== null)
                this.form.DateOfBirth = this.formatDateForBackend(
                    this.form.DateOfBirth
                );

            if (this.editedIndex === -1) {
                this.$inertia.post(route("api.insertAccidentRep"), this.form, {
                    forceFormData: true,
                    onSuccess: () => {
                        this.loading = true;
                        this.successMessage = true;
                        setTimeout(() => {
                            this.$refs.form.reset();
                            window.location.reload();
                        }, 2000);
                    },
                    onError: (errors) => {
                        this.loading = false;
                        this.errorMessage = true;
                        console.log(errors);
                        this.form.errors = errors;
                    },
                });
            } else {
                const pdfDoc = await this.createEmailAttachment(
                    this.accident.ID,
                    this.form
                );
                this.form.emailPdf = pdfDoc;
                this.$inertia.post(route("api.approveAccidents"), this.form, {
                    forceFormData: true,
                    onSuccess: () => {
                        this.loading = true;
                        this.successMessage = true;
                        setTimeout(() => {
                            this.hideAccident();
                            this.getWaitingAccidents();
                        }, 2000);
                    },
                    onError: (errors) => {
                        this.loading = false;
                        this.errorMessage = true;
                        console.log(errors);
                        this.form.errors = errors;
                    },
                });
            }
        },

        formatAccidentDescriptionForSubmission() {
            return `Before:\n${this.detailedDescription.before}\nDuring:\n${this.detailedDescription.during}\nAfter:\n${this.detailedDescription.after}`;
        },

        parseAccidentDescriptionForEdit() {
            const description = this.accident?.AccidentDescription;

            if (!description) {
                this.detailedDescription = { before: '', during: '', after: '' };
                return;
            }

            const hasStructuredFormat =
                /Before:/i.test(description) ||
                /During:/i.test(description) ||
                /After:/i.test(description);

            if (!hasStructuredFormat) {
                // fallback: no structure found so put everything in "during"
                this.detailedDescription = {
                    before: '',
                    during: description.trim(),
                    after: ''
                };
                return;
            }

            const beforeMatch = description.match(/Before:(.*?)(During:|After:|$)/is);
            const duringMatch = description.match(/During:(.*?)(Before:|After:|$)/is);
            const afterMatch  = description.match(/After:(.*?)(Before:|During:|$)/is);

            this.detailedDescription = {
                before: beforeMatch?.[1]?.trim() || '',
                during: duringMatch?.[1]?.trim() || '',
                after: afterMatch?.[1]?.trim() || '',
            };
        },

        formatDateForFrontEnd(dateString) {
            return moment(dateString).format("MM/DD/YYYY");
        },

        formatTimeForFrontEnd(timeString) {
            const [hours, minutes, seconds] = timeString.split(":");
            const time = {
                hours: hours,
                minutes: minutes,
                seconds: seconds,
            };
            return time;
        },

        selectFatality(item, index) {
            this.FatalityOptions.forEach((option) => {
                option.color = "blue";
            });
            this.FatalityOptions[index].color = "primary";
            this.form.Fatality = item.value;
        },

        handleImages(imgArray) {
            imgArray.forEach((img) => {
                if (img.ID === "") {
                    let localPath = img.Image.split("\\public\\");
                    img.Image = "/" + localPath[1];
                } else {
                    img.Image = `/images/Safety/Analysis/${img.FKAccidentID}/${img.Image}`;
                }
            });
            this.form.Images = imgArray;
        },

        async removeImage(img, index) {
            if (
                window.confirm(
                    "The deleted picture can not be recovered.\nAre you sure you want to delete it?"
                )
            ) {
                try {
                    await axios
                        .post(
                            route("api.deletePicture", {
                                ID: img.ID,
                                URL: img.Image,
                            })
                        )
                        .then((response) => {
                            if (response.data === true) {
                                this.form.Images.splice(index, 1);
                            } else {
                                window.alert("Error Removing Picture");
                            }
                        });
                } catch (err) {
                    console.log(err);
                }
            }
        },

        hideAccident() {
            this.$emit("hideAccident");
        },

        getWaitingAccidents() {
            this.$emit("getWaitingAccidents");
        },

        createEmailAttachment(ID, data) {
            function createRow(label, data) {
                return {
                    columns: [
                        {
                            text: label,
                            style: "subheader",
                            width: "20%",
                        },
                        {
                            text: data || "",
                            width: "*",
                        },
                    ],
                };
            }

            function createRow_(label, data) {
                return {
                    columns: [
                        {
                            text: label,
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text: data || "",
                            width: "*",
                        },
                    ],
                };
            }

            function insertLine() {
                return {
                    canvas: [
                        {
                            type: "line",
                            x1: 0,
                            y1: 5,
                            x2: 760,
                            y2: 5,
                            lineWidth: 1,
                        },
                    ],
                };
            }

            var docDefinition = {
                content: [
                    {
                        text:
                            (ID === null
                                ? "Accident Report - "
                                : "New Accident Report - ") + data.Fatality,
                        style: "header",
                    },
                    {
                        text:
                            "Accident On: " +
                            moment(data.IncidentDate).format("MM-DD-YY"),
                        style: "subheader",
                        alignment: "right",
                    },
                    insertLine(),
                    {
                        text: "Employee Information",
                        style: "sectionHeader",
                        margin: [0, 10],
                    },
                    createRow("Person Involved:", data.PersonInvolved),
                    createRow("Home Address:", data.HomeAddress),
                    {
                        columns: [
                            {
                                text: "Home Telephone:",
                                style: "subheader",
                                width: "20%",
                            },
                            {
                                text: data.HomeNumber || "",
                            },
                            {
                                text: "Cell Phone:",
                                style: "subheader",
                                width: "20%",
                            },
                            {
                                text: data.CellNumber || "",
                            },
                        ],
                    },
                    createRow(
                        "Date Of Birth:",
                        data.DateOfBirth && data.DateOfBirth != "0000-00-00"
                            ? moment(data.DateOfBirth).format("MM-DD-YYYY")
                            : ""
                    ),
                    insertLine(),
                    {
                        text: "Incident Information",
                        style: "sectionHeader",
                        margin: [0, 10],
                    },
                    createRow("Witness:", data.Witness),
                    createRow("Worker Title:", data.Title),
                    createRow(
                        "Incident Date/Time:",
                        moment(
                            data.IncidentDate + "T" + data.IncidentTime,
                            "YYYY-MM-DDThh:mm a"
                        ).format("MM-DD-YY h:mm a")
                    ),
                    createRow("Building:", data.Building),
                    createRow("Incident Location:", data.Location),
                    createRow(
                        "Employee's regular shift:",
                        moment(data.RegularFrom, "hh:mm a").format("h:mm a") +
                            " - " +
                            moment(data.RegularTo, "hh:mm a").format("h:mm a")
                    ),
                    insertLine(),
                    {
                        text: "Injury Windows",
                        style: "sectionHeader",
                        margin: [0, 10],
                    },
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true,
                        alignment: "center",
                        margin: [0, 0, 0, 5],
                    },
                    sectionHeader: {
                        fontSize: 16,
                        bold: true,
                        alignment: "center",
                        margin: [0, 5, 0, 5],
                    },
                    subheader: {
                        fontSize: 14,
                        bold: true,
                        margin: [0, 0, 0, 5],
                    },
                    smallText: {
                        fontSize: 10,
                        margin: [0, 0, 0, 5],
                    },
                },
                defaultStyle: {
                    fontSize: 12,
                    margin: [0, 0, 0, 5],
                },
                pageSize: "A3",
            };

            for (var i = 0; i < data._Duplicate.length; i++) {
                docDefinition.content.push(
                    createRow_("Nature Of Injury:", data._Duplicate[i].Injury),
                    createRow_(
                        "Please Explain:",
                        data._Duplicate[i].InjuryExplain
                    ),
                    createRow_(
                        "Body Parts Affected:",
                        data._Duplicate[i].AffectedParts
                    )
                );
            }

            docDefinition.content.push(
                {
                    columns: [
                        {
                            text: "Medical Treatment:",
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text:
                                data.MedicalTreatment === true ||
                                data.MedicalTreatment == "1"
                                    ? "Yes"
                                    : "No",
                            width: "15%",
                        },
                        {
                            text: "Type Of Treatment:",
                            style: "subheader",
                            width: "20%",
                        },
                        {
                            text: data.TypeOfTreatment || "",
                            width: "*",
                        },
                    ],
                },
                createRow_("Doctor/Hospital Name:", data.NameOfDocHos),
                createRow_("Doctor/Hospital Information:", data.APOfDocHos),
                {
                    columns: [
                        {
                            text: "Leave Work:",
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text:
                                data.LeaveWork === true || data.LeaveWork == "1"
                                    ? "Yes"
                                    : "No",
                            width: "15%",
                        },
                        {
                            text: "Leave Work Time:",
                            style: "subheader",
                            width: "20%",
                        },
                        {
                            text:
                                data.LeaveWorkTime != "00:00:00" &&
                                data.LeaveWork == true
                                    ? moment(
                                          data.LeaveWorkTime,
                                          "hh : mm a"
                                      ).format("hh:mm a")
                                    : "",
                            width: "*",
                        },
                    ],
                },
                insertLine(),
                {
                    text: "Incident Description",
                    style: "sectionHeader",
                    margin: [0, 10],
                },
                {
                    columns: [
                        {
                            text: "Accident Description:",
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text: data.AccidentDescription,
                            style: "smallText",
                            width: "*",
                        },
                    ],
                },
                createRow_("Equipment/Material/Chemical:", data.ItemInvolved),
                {
                    columns: [
                        {
                            text: "Used Proper Procedure:",
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text:
                                data.ProperProcedure === true ||
                                data.ProperProcedure == "1"
                                    ? "Yes"
                                    : "No",
                            width: "15%",
                        },
                        {
                            text: "If not, explain:",
                            style: "subheader",
                            width: "15%",
                        },
                        {
                            text: data.ProcedureExplain || "",
                            style: "smallText",
                            width: "*",
                        },
                    ],
                },
                {
                    columns: [
                        {
                            text: "Wearing PPE:",
                            style: "subheader",
                            width: "25%",
                        },
                        {
                            text:
                                data.WearingPPE === true ||
                                data.WearingPPE == "1"
                                    ? "Yes"
                                    : "No",
                            width: "15%",
                        },
                        {
                            text: "If not, explain:",
                            style: "subheader",
                            width: "15%",
                        },
                        {
                            text: data.PPEExplain || "",
                            style: "smallText",
                            width: "*",
                        },
                    ],
                },
                createRow_("Reported To:", data.ReportedTo),
                insertLine()
            );

            return new Promise((resolve, reject) => {
                const doc = pdfMake.createPdf(docDefinition);
                doc.getBase64((data) => {
                    resolve(data);
                });
            });
        },

        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },

        onClearClicked_Image() {
            this.form.imageAttachment = [];
        },

        translate() {
            this.language = this.language === "english" ? "spanish" : "english";
        },

        downloadPolicyPDF() {
            const link = document.createElement('a');
            link.href = `/pdf/Safety/ReportAccidentPolicy_${this.language}.pdf`;
            link.download = 'D3 LLC Employee Accident Policy and Standard Operating Procedure.pdf';
            link.click();
        }
    },
};
</script>

<style lang="css" scoped>
.center-container {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    margin-top: 100px;
}

.title {
    margin-left: 10px;
    font-size: 24px;
}

ul {
    list-style-type: "- ";
}

.styled-h3 {
    margin-right: 10px;
    font-weight: bold;
    text-decoration: underline;
}

.required-label::after {
    content: "*";
    color: red;
    margin-left: 4px;
}

.semi-required-label::after {
    content: "*";
    color: black;
    margin-left: 4px;
}

.image-container {
    display: flex;
}

.close-image {
    opacity: 0;
    transition: opacity 0.2s;
}

.image-container:hover .close-image {
    opacity: 1;
    transition: opacity 0.2s;
}
</style>
